import { jsx } from "react/jsx-runtime";
import { C as Card } from "../../../../Card-a7aa60bc.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import "react";
import "../../../../utils-65a8d69b.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "../../../../index-e71f83b5.js";
function FlashCard(props) {
  const { children, elevation = "none" } = props;
  return /* @__PURE__ */ jsx("div", { className: `${COMMON_CLASSNAME} flash-card`, children: /* @__PURE__ */ jsx(Card, { className: `shadow-flash-${elevation}`, children }) });
}
export {
  FlashCard as default
};
//# sourceMappingURL=FlashCard.js.map
